// Helpers compartidos del módulo de layaways de armas (dashboard).
// Las escrituras pasan por Cloud Functions (functions/layaways.js) para que
// los totales y el historial queden consistentes; las lecturas de lista van
// directo a Firestore.
import axios from 'axios';
import { getCurrentIdentity } from '../protectedRoute';

export const FUNCTIONS_BASE = 'https://us-central1-bb-target-center.cloudfunctions.net';

export const LAYAWAY_STATUS = {
  active: { label: 'Activo', color: 'info' },
  overdue: { label: 'Vencido', color: 'error' },
  paid: { label: 'Saldado', color: 'success' },
  completed: { label: 'Entregado', color: 'default' },
  cancelled: { label: 'Cancelado', color: 'warning' },
};
// Etiqueta de estado según el tipo (en custodia "completed" = armas retiradas)
export const statusMeta = (l, st) => {
  const m = LAYAWAY_STATUS[st] || LAYAWAY_STATUS.active;
  if (isCustody(l) && st === 'completed') return { ...m, label: 'Retirada' };
  if (isCustody(l) && st === 'overdue') return { ...m, label: 'Almacenaje vencido' };
  // Arma saldada que no recogieron a tiempo: debe almacenaje (cláusula 7)
  if (l && l.status === 'paid' && st === 'overdue') return { ...m, label: 'Saldado · almacenaje vencido' };
  return m;
};

export const PAYMENT_KIND = {
  deposit: 'Depósito inicial',
  payment: 'Abono',
  storage: 'Almacenaje',
  extension: 'Extensión de contrato',
  fee: 'Trámite fallecimiento / inscripción',
  note: 'Nota',
};
export const isDeceasedCustody = (l) => Boolean(l && l.kind === 'custody' && l.custodyType === 'deceased');

export const PAYMENT_METHOD = {
  cash: 'Efectivo',
  ath: 'ATH Móvil',
  card: 'Tarjeta (tienda)',
  card_online: 'Tarjeta (app/web)',
  check: 'Cheque',
  other: 'Otro',
};

export const DEFAULT_LAYAWAY_TERMS = [
  '1. Para separar el arma, el cliente pagará un depósito no reembolsable equivalente al 50% del precio de venta en armas nuevas o al 75% del precio de venta en armas usadas.',
  '2. El balance será pagado dentro de los próximos 120 días calendario.',
  '3. De no saldar el balance del arma de fuego separada dentro del término establecido, dispondremos del arma separada sin derecho a reembolso, sin notificación previa alguna.',
  '4. Si desiste de comprar el arma separada, se retendrá el depósito pagado para la misma.',
  '5. Si desea cambiar o transferir el arma o depósito a otra persona tendrá un cargo de 10% del valor del arma.',
  '6. De ser denegada la licencia de armas o traspaso por alguna agencia estatal o federal (ATF, Policía de Puerto Rico u otra), se retendrá el 50% pagado para separar la misma.',
  '7. Para contratos de armas de fuego ya saldados; transcurridos los 120 días calendario contados desde la fecha de separación del arma de fuego, el cliente pagará $20.00 mensuales de almacenaje.',
  '8. Antes de que culminen los 120 días calendario, si el cliente no ha saldado el arma de fuego, podrá extender su contrato por 60 días adicionales mediante el pago de $30.00.',
  '9. Una vez culminados los 120 días calendario sin que el cliente haya saldado, retirado, realizado el pago correspondiente para la extensión de su contrato o almacenaje, el contrato de arma de fuego (layaway) quedará automáticamente cancelado sin derecho a reembolso.',
  '10. Toda arma de fuego que lleve 6 meses o más almacenada sin que el cliente pague la correspondiente cuota de almacenaje de $20.00 será puesta a la venta, sin notificación previa y sin derecho a reembolso.',
  '11. No somos responsables por daños sufridos a sus armas de fuego durante la custodia.',
].join('\n');

// Contrato completo (16 cláusulas, PDF 4707E8C9 de Afía 2026-10-06). Se imprime
// al crear el layaway para que el cliente firme. Editable en Tarifas.
export const DEFAULT_LAYAWAY_CONTRACT = [
  '1. Para separar el arma, el cliente pagará un depósito no reembolsable equivalente al 50% del precio de venta en armas nuevas o al 75% del precio de ventas en armas usadas.',
  '2. El balance será pagado dentro de los próximos 120 días del calendario.',
  '3. De no saldar el balance del arma de fuego separada dentro del término establecido, dispondremos del arma separada sin derecho a reembolso, sin notificación previa alguna.',
  '4. Si desiste de comprar el arma separada, se retendrá el depósito pagado para la misma.',
  '5. Si desea cambiar o transferir el arma o depósito a otra persona tendrá un cargo de 10% del valor del arma.',
  '6. De ser denegada la licencia de armas o traspaso por alguna agencia Estatal o Federal tales como: ATF, la Policía de Puerto Rico o cualquier otra, se retendrá el 50% pagado para separar la misma.',
  '7. Para contrato de compra de armas; transcurridos los 120 días calendario contados desde la fecha de separación del arma de fuego, el cliente pagará $20.00 mensuales de almacenaje y deberá estar saldada.',
  '8. Toda arma de fuego dejada en custodia por fallecimiento del dueño pagará $125.00 por arma de fuego para los trámites correspondientes con la Policía de Puerto Rico y un almacenamiento de 180 días calendarios.',
  '9. Toda arma de fuego que lleve 6 meses o más almacenada sin que el cliente pague la correspondiente cuota de almacenaje de $20.00, será puesta a la venta, sin notificación previa y sin derecho a reembolso.',
  '10. No somos responsables por daños sufridos a sus armas de fuego durante la custodia.',
  '11. Toda arma de fuego depositada en B&B Target Center, Inc. para custodia temporera, licencia vencida, almacenamiento o cualquier otro trámite pagará $20.00 de almacenaje por cada arma de fuego.',
  '12. Transcurrido 6 meses sin pagar la correspondiente cuota de almacenaje, B&B Target Center, Inc. tendrá derecho a traspasar el o las armas de fuego almacenada a su nombre, sin previa notificación y poner la(s) misma(s) en venta.',
  '13. El cliente, depositante, dueño, representante, heredero o cualquier otra función es responsable de traer los documentos requeridos para traspasar las armas a su comprador. Declaratoria de herederos, declaración jurada de los herederos traspasando el arma de fuego a la armería para luego a quien designe, de no ser así el o las arma(s) de fuego pasará a B&B Target Center, Inc. transcurridos los 6 meses desde su depósito en dicha armería.',
  '14. Garantías: Las mismas serán enviadas directamente al fabricante, siendo B&B Target Center, Inc. sólo un medio de transporte. B&B Target Center, Inc. no es responsable del tiempo que tome el fabricante en procesar la reparación. Envíos por garantía tendrán un costo de $45.00 a $75.00 asumiéndolo el comprador.',
  '15. Traspasos de armas de fuego a Estados Unidos o armas de fuego recibidas de Estados Unidos el cliente o comprador pagará $125.00 en armas cortas, $150.00 armas largas o un 10% del precio del arma de fuego. Toda arma de fuego dejada por más de 6 meses sin que el cliente envíe la información necesaria para realizar el envío se pondrá a la venta sin notificación previa alguna, ya que se entiende que no interesa realizar el envío.',
  '16. Una vez culminados los 120 días calendario sin que el cliente haya saldado, retirado o realizado el pago correspondiente para la extensión de su contrato de layaway, este quedará automáticamente cancelado sin derecho a reembolso. El cliente podrá extender dicho término mediante el pago de la cuota de extensión antes de la fecha de vencimiento fijada en este contrato.',
].join('\n');

export const DEFAULT_LAYAWAY_SETTINGS = {
  termsText: DEFAULT_LAYAWAY_TERMS,
  contractText: DEFAULT_LAYAWAY_CONTRACT,
  autoCancelEnabled: true,
  autoCancelGraceDays: 15,
  termDays: 120,
  storageFeeCents: 2000,
  storageFeeTaxable: true,
  storageMonthDays: 30,
  minPaymentCents: 500,
  newDepositPct: 50,
  usedDepositPct: 75,
  reminderDaysBefore: 7,
  forfeitAfterMonths: 6,
  customerCanExtend: true,
  customerCanPay: true,
  priceTaxable: true,
  // Extensión de contrato (cláusula 8, 2026-10-09): 60 días por $30 + IVU si
  // no ha saldado; el almacenaje ($20/mes) solo aplica al arma saldada.
  extensionFeeCents: 3000,
  extensionDays: 60,
  extensionMaxCount: 1,
  extensionFeeTaxable: true,
  storageMustPayOwed: true,
  // Custodia por fallecimiento (cláusula 8): $125/arma, incluye 180 días
  deceasedFeeCents: 12500,
  deceasedFeeDays: 180,
  deceasedFeeTaxable: true,
};

export const TAX_RATE = 0.115;
export const calcTaxCents = (c) => Math.round(Math.max(0, Number(c) || 0) * TAX_RATE);

export const formatPrice = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;
export const dollarsToCents = (v) => Math.round((parseFloat(String(v).replace(/[^0-9.]/g, '')) || 0) * 100);
export const centsToDollars = (c) => ((Number(c) || 0) / 100).toFixed(2);

export const toDate = (v) => {
  if (!v) return null;
  if (typeof v.toDate === 'function') return v.toDate();
  if (v instanceof Date) return v;
  if (typeof v === 'object' && typeof v.seconds === 'number') return new Date(v.seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const fmtDate = (v) => {
  const d = toDate(v);
  return d ? d.toLocaleDateString('es-PR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
};
export const fmtDateTime = (v) => {
  const d = toDate(v);
  return d ? d.toLocaleString('es-PR', { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—';
};
export const toInputDate = (v) => {
  const d = toDate(v);
  if (!d) return '';
  const y = d.getFullYear(); const m = String(d.getMonth() + 1).padStart(2, '0'); const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

// Estado "efectivo": un activo (o un SALDADO sin recoger) con fecha límite
// pasada se muestra como vencido. El saldado vencido debe almacenaje.
export const effectiveStatus = (l) => {
  if (!l) return 'active';
  if (l.status === 'active' || l.status === 'paid') {
    const due = toDate(l.dueDate);
    if (due) {
      const today = new Date(); today.setHours(0, 0, 0, 0);
      if (due < today) return 'overdue';
    }
  }
  return l.status || 'active';
};

export const daysLeft = (l) => {
  const due = toDate(l && l.dueDate);
  if (!due) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.ceil((due - today) / 86400000);
};

// Líneas no vacías de los términos (para listas numeradas)
export const termsLines = (settings) => String((settings && settings.termsText) || DEFAULT_LAYAWAY_TERMS).split('\n').map((l) => l.trim()).filter(Boolean);

export const contractLines = (settings) => String((settings && settings.contractText) || DEFAULT_LAYAWAY_CONTRACT).split('\n').map((l) => l.trim()).filter(Boolean);

// Fecha en que el sistema cancela solo un layaway vencido (null si está apagado)
export const autoCancelDate = (l, settings) => {
  if (!l || !settings || settings.autoCancelEnabled === false) return null;
  const due = toDate(l.dueDate);
  if (!due) return null;
  const d = new Date(due); d.setDate(d.getDate() + Math.max(0, Number(settings.autoCancelGraceDays) || 0));
  return d;
};

const esc = (v) => String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const fmtPhone = (p) => { const d = String(p || '').replace(/\D/g, ''); return d.length === 10 ? `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}` : (p || ''); };

// Imprime el "Contrato de Armas de Fuego" con los datos del layaway ya
// llenos, para que el cliente lo firme en tienda (pedido 2026-10-06). Debe
// llamarse desde un click (window.open) para que el navegador no lo bloquee.
export const printLayawayContract = (l, settings) => {
  const w = window.open('', '_blank', 'width=850,height=1000');
  if (!w) { window.alert('El navegador bloqueó la ventana de impresión. Permite ventanas emergentes para este sitio.'); return; }
  const f = (v) => (v ? esc(v) : '<span class="blank"></span>');
  const price = l.priceCents ? formatPrice(l.priceCents) : '';
  const priceNote = l.priceTaxCents > 0 ? ` <span class="small">(${formatPrice(l.basePriceCents)} + IVU ${formatPrice(l.priceTaxCents)})</span>` : '';
  const dep = l.depositCents ? formatPrice(l.depositCents) : '';
  const start = toDate(l.startDate) || new Date();
  const due = toDate(l.dueDate);
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Contrato ${esc(l.serialNumber || '')}</title>
  <style>
    @page{size:letter;margin:0.55in}
    body{font-family:Arial,Helvetica,sans-serif;color:#111;margin:0;font-size:11.5px;line-height:1.35}
    h1{font-size:17px;text-align:center;margin:0;letter-spacing:.3px}
    h2{font-size:13px;text-align:center;margin:2px 0 14px;font-weight:normal}
    .row{display:flex;gap:18px;margin:5px 0}
    .f{flex:1;display:flex;align-items:flex-end;gap:6px;white-space:nowrap}
    .f .v{flex:1;border-bottom:1px solid #222;padding:0 4px 1px;min-height:15px;white-space:normal;font-weight:bold}
    .blank{display:inline-block;min-width:60px}
    .small{font-weight:normal;color:#555;font-size:10px}
    ol{margin:12px 0 0;padding-left:20px}
    ol li{margin:0 0 4px;text-align:justify}
    .cert{margin-top:12px;text-align:center;font-weight:bold;font-size:11px;padding:0 20px}
    .sig{display:flex;justify-content:space-between;align-items:flex-end;margin-top:34px;gap:40px}
    .sig .l{flex:1}
    .sig .line{border-bottom:1px solid #222;height:22px;position:relative}
    .sig .x{position:absolute;left:0;bottom:2px;font-size:16px;font-weight:bold}
    .sig .cap{font-size:9.5px;letter-spacing:1px;margin-top:3px}
    .foot{text-align:center;margin-top:26px;font-size:10.5px;color:#333;line-height:1.4}
    .ref{margin-top:10px;font-size:9.5px;color:#666;text-align:right}
  </style></head><body>
  <h1>B&amp;B TARGET CENTER, INC.</h1>
  <h2>Contrato de Armas de Fuego${l.contractNumber ? ` &nbsp;·&nbsp; Núm. ${esc(l.contractNumber)}` : ''}</h2>
  <div class="row"><div class="f">Nombre: <span class="v">${f(l.memberName)}</span></div></div>
  <div class="row"><div class="f">Dirección: <span class="v">${f(l.memberAddress)}</span></div></div>
  <div class="row"><div class="f">Teléfono: <span class="v">${f(fmtPhone(l.memberPhone))}</span></div><div class="f">Email: <span class="v">${f(l.memberEmail)}</span></div></div>
  ${isCustody(l) ? `
  <div class="row" style="margin-top:12px"><div class="f">Tipo de contrato: <span class="v">Custodia ${isDeceasedCustody(l) ? 'por fallecimiento / inscripción' : '/ almacenamiento'} de ${firearmCount(l)} arma${firearmCount(l) === 1 ? '' : 's'} de fuego</span></div></div>
  <table style="width:100%;border-collapse:collapse;margin-top:6px;font-size:11px"><tr><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">#</th><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">Tipo</th><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">Marca</th><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">Modelo</th><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">Calibre</th><th style="text-align:left;border-bottom:1px solid #222;padding:2px 4px">Núm. de Serie</th></tr>
  ${(l.firearms || []).map((g, i) => `<tr><td style="padding:3px 4px;border-bottom:1px solid #ccc">${i + 1}</td><td style="padding:3px 4px;border-bottom:1px solid #ccc">${esc(g.firearmType)}</td><td style="padding:3px 4px;border-bottom:1px solid #ccc"><b>${esc(g.brand)}</b></td><td style="padding:3px 4px;border-bottom:1px solid #ccc">${esc(g.model)}</td><td style="padding:3px 4px;border-bottom:1px solid #ccc">${esc(g.caliber)}</td><td style="padding:3px 4px;border-bottom:1px solid #ccc"><b>${esc(g.serialNumber)}</b></td></tr>`).join('')}</table>
  <div class="row"><div class="f">Fecha de depósito: <span class="v">${esc(fmtDate(start))}</span></div><div class="f">${isDeceasedCustody(l) ? `Trámite: <span class="v">${formatPrice(settings && settings.deceasedFeeCents != null ? settings.deceasedFeeCents : 12500)} por arma (incluye ${(settings && settings.deceasedFeeDays) || 180} días); luego ${formatPrice(settings && settings.storageFeeCents != null ? settings.storageFeeCents : 2000)} por arma al mes</span>` : `Almacenaje: <span class="v">${formatPrice(settings && settings.storageFeeCents != null ? settings.storageFeeCents : 2000)} por arma al mes</span>`}</div><div class="f">Pagado hasta: <span class="v">${due ? fmtDate(due) : '<span class="blank"></span>'}</span></div></div>` : `
  <div class="row" style="margin-top:12px"><div class="f">Tipo de Arma: <span class="v">${f(l.firearmType)}</span></div><div class="f">Marca: <span class="v">${f(l.brand)}</span></div></div>
  <div class="row"><div class="f">Modelo: <span class="v">${f(l.model)}</span></div><div class="f">Calibre: <span class="v">${f(l.caliber)}</span></div></div>
  <div class="row"><div class="f">Núm. de Serie: <span class="v">${f(l.serialNumber)}</span></div><div class="f">Precio: <span class="v">${price ? `${price}${priceNote}` : '<span class="blank"></span>'}</span></div></div>
  <div class="row"><div class="f">Condición: <span class="v">${l.condition === 'used' ? 'Usada' : 'Nueva'}</span></div><div class="f">Depósito: <span class="v">${dep || '<span class="blank"></span>'}</span></div><div class="f">Fecha límite: <span class="v">${due ? fmtDate(due) : '<span class="blank"></span>'}</span></div></div>`}
  <ol>${contractLines(settings).map((t) => `<li>${esc(t.replace(/^\d+[.)]\s*/, ''))}</li>`).join('')}</ol>
  <p class="cert">Certifico que luego de haber leído la información que aparece en este documento, estoy de acuerdo con las condiciones que aquí se estipulan. En adición, estoy dispuesto a asumir el riesgo sobre el deterioro del arma de fuego.</p>
  <div class="sig">
    <div class="l"><div class="line"><span class="x">X</span></div><div class="cap">FIRMA DEL COMPRADOR<br/><span style="letter-spacing:0;font-size:9px">He leído, entendido y acepto las condiciones</span></div></div>
    <div class="l" style="flex:.7"><div class="line" style="text-align:center;font-size:12px;padding-bottom:3px">${esc(fmtDate(start))}</div><div class="cap" style="text-align:center">FECHA</div></div>
  </div>
  <div class="foot">369 Ave. San Claudio Suite #3<br/>San Juan, P.R. 00926<br/>Tel. (787) 755-9060 &nbsp; Fax. (787) 755-9290<br/>E-mail: bbtargetcenter@gmail.com</div>
  <div class="ref">Impreso ${new Date().toLocaleString('es-PR')}${l.id ? ` · Ref. ${esc(l.id)}` : ''}</div>
  <script>window.onload=function(){setTimeout(function(){window.print()},150)}</script>
  </body></html>`;
  w.document.write(html);
  w.document.close();
};

export const CUSTODY_REASON = {
  temporary: 'Custodia Temporera',
  deceased: 'Persona Fallecida',
  expired_license: 'Licencia Vencida',
};
export const custodyReasonOf = (l) => (l && CUSTODY_REASON[l.custodyReason] ? l.custodyReason : (isDeceasedCustody(l) ? 'deceased' : 'temporary'));

// Imprime el documento "Traspaso a Armería B & B Target Center" (PDF 60869EF8
// de Afía, 2026-10-19) con los datos de la custodia: quien entrega (el cliente
// de la custodia, que firma) a la izquierda y el fallecido / propietario a la
// derecha. Si no se capturó un propietario distinto y no es por fallecimiento,
// se repiten los datos del cliente. Debe llamarse desde un click (window.open).
export const printCustodyTransfer = (l, settings) => {
  const w = window.open('', '_blank', 'width=850,height=1000');
  if (!w) { window.alert('El navegador bloqueó la ventana de impresión. Permite ventanas emergentes para este sitio.'); return; }
  const reason = custodyReasonOf(l);
  const box = (on) => `<span class="box">${on ? 'X' : '&nbsp;'}</span>`;
  const line = (label, v, cls = '') => `<div class="fl ${cls}"><span class="lb">${label}</span><span class="vl">${v ? esc(v) : '&nbsp;'}</span></div>`;
  const ownerGiven = l.owner && Object.values(l.owner).some(Boolean);
  const owner = ownerGiven ? l.owner : (reason === 'deceased' ? {} : { name: l.memberName, address: l.memberAddress, phone: l.memberPhone, licenseNumber: l.licenseNumber });
  const rows = Math.max(4, (l.firearms || []).length);
  const guns = Array.from({ length: rows }, (_, i) => (l.firearms || [])[i] || {});
  const start = toDate(l.startDate);
  const fee = settings && settings.deceasedFeeCents != null ? settings.deceasedFeeCents : 12500;
  const feeDays = (settings && settings.deceasedFeeDays) || 180;
  const storage = settings && settings.storageFeeCents != null ? settings.storageFeeCents : 2000;
  const forfeit = (settings && settings.forfeitAfterMonths) || 6;
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Traspaso ${esc(l.memberName || '')}</title>
  <style>
    @page{size:letter;margin:0.5in}
    body{font-family:Arial,Helvetica,sans-serif;color:#111;margin:0;font-size:10.5px;line-height:1.3}
    h1{font-size:15px;text-align:center;margin:0 0 6px}
    .hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px}
    .hdr .pol{font-size:10.5px;line-height:1.3}
    table.g{width:100%;border-collapse:collapse;margin:4px 0 8px}
    table.g th,table.g td{border:1px solid #222;padding:3px 5px;font-size:10.5px;text-align:left;height:16px}
    table.g th{background:#eee;font-weight:bold}
    .box{display:inline-block;width:16px;height:13px;border:1px solid #222;text-align:center;line-height:13px;font-weight:bold;margin:0 4px 0 0;vertical-align:middle}
    .opts{display:flex;justify-content:space-around;margin:6px 0 8px;font-weight:bold}
    p.t{text-align:justify;margin:4px 0}
    .two{display:flex;gap:28px;margin-top:10px}
    .two>div{flex:1}
    .fl{display:flex;align-items:flex-end;margin:7px 0}
    .fl .lb{white-space:nowrap;margin-right:6px}
    .fl .vl{flex:1;border-bottom:1px solid #222;min-height:14px;padding:0 3px 1px;font-weight:bold}
    .lic{display:flex;gap:6px}
    .lic .fl{flex:1}
    .sub{font-weight:bold;margin:8px 0 2px}
    .sig{margin-top:14px}
    .cert{font-size:10px;margin-top:8px}
    .costs{display:flex;gap:18px;margin-top:10px;font-size:10px}
    .costs>div{flex:1;border:1px solid #222;padding:5px 7px}
    .costs b{display:block;margin-bottom:2px}
    .foot{text-align:center;margin-top:12px;font-size:9.5px;line-height:1.35}
    .ref{margin-top:4px;font-size:9px;color:#666;text-align:right}
  </style></head><body>
  <h1>Traspaso a Armería B &amp; B Target Center</h1>
  <div class="hdr">
    <div class="pol">Policía de Puerto Rico<br/>Registro de Armas<br/>Cuartel General, San Juan</div>
    <div class="fl" style="width:240px;margin:0">${line('Fecha:', start ? fmtDate(start) : '')}</div>
  </div>
  <div>He entregado el arma de fuego:</div>
  <table class="g"><tr><th style="width:18%">Marca</th><th style="width:16%">Tipo</th><th style="width:22%">Modelo</th><th style="width:26%">Núm. de Serie</th><th>Calibre</th></tr>
  ${guns.map((g) => `<tr><td>${esc(g.brand || '')}</td><td>${esc(g.firearmType || '')}</td><td>${esc(g.model || '')}</td><td>${esc(g.serialNumber || '')}</td><td>${esc(g.caliber || '')}</td></tr>`).join('')}</table>
  <div>Traspaso Armería B &amp; B Target Center ya sea por:</div>
  <div class="opts"><span>${box(reason === 'temporary')} Custodia Temporera</span><span>${box(reason === 'deceased')} Persona Fallecida</span><span>${box(reason === 'expired_license')} Licencia Vencida</span></div>
  <p class="t">Hago entrega de dicha(s) arma(s) de fuego(s) para los trámites pertinentes de modo que transcurrido un término de tiempo de un (1) año y tras ninguna comunicación de mi parte y tras no cumplir con la entrega de documentos y/o pagos pertinentes para proceder con el servicio acepto que dicha(s) arma(s) sean traspasada a la armería B&amp;B Target Center de modo que sea sacada de mi expediente y puesta a la venta. B&amp;B Target Center Inc. con número de licencia de armero 183543, licencia federal 1-66-00167 y representada por el Sr. Luis A. Bermúdez.</p>
  <p class="t">Si la(s) arma(s) de fuego antes mencionada pertenecían a un fallecido o una persona con licencia de armas vencida, la persona que hace entrega de estas tiene la responsabilidad de entregar, vía correo electrónico (bbtargetcenter@gmail.com) o personalmente en un término de un (1) año, los siguientes documentos: información completa del fallecido, licencia de arma y conducir del fallecido, declaratoria de herederos y declaración jurada por parte de todos los herederos certificando el traspaso de dichas armas de fuego a la armería B&amp;B Target Center (preguntar al personal por información esencial de la armería que debe ser incluida en este documento de utilizar un notario privado). De no tener alguno de estos documentos en el término antes mencionado deberá enviar un correo electrónico notificándolo. Además, deberán adjuntar a esta forma la licencia de conducir y licencia de armas, si posee, de la persona que hace entrega de la(s) arma(s).</p>
  <div class="two">
    <div>
      <div class="sub">Persona que hace entrega:</div>
      ${line('Nombre', l.memberName)}
      ${line('Dirección', l.memberAddress)}
      ${line('Tel:', fmtPhone(l.memberPhone))}
      <div class="lic">${line('Lic. Armas', l.licenseNumber)}${line('Tiro', '')}${line('Caza', '')}</div>
      <div class="fl sig"><span class="lb">Firma</span><span class="vl">&nbsp;</span></div>
    </div>
    <div>
      <div class="sub">Información del Fallecido / Propietario del arma:</div>
      ${line('Nombre:', owner.name)}
      ${line('Dirección:', owner.address)}
      ${line('Tel:', fmtPhone(owner.phone))}
      <div class="lic">${line('Lic. Armas', owner.licenseNumber)}${line('Tiro', owner.shootingLicense)}${line('Caza', owner.huntingLicense)}</div>
      <div class="fl sig"><span class="vl" style="text-align:center;font-weight:normal">&nbsp;</span></div>
      <div style="text-align:center;font-size:9.5px">Luis Crespo, Gerente / Personal</div>
    </div>
  </div>
  <p class="cert">Al firmar este documento aceptas las condiciones y los términos aquí expuestos.</p>
  <div class="costs">
    <div><b>Costos (Persona Fallecida y/o Inscripción de Armas, puede aplicar a licencias vencidas):</b>- Traspaso ${formatPrice(fee)} por cada arma<br/>- Transcurridos ${feeDays} días tiene un costo de ${formatPrice(storage)} mensuales por arma de fuego.</div>
    <div><b>Costos (Custodia)</b>- ${formatPrice(storage)} mensual por arma</div>
    <div><b>&nbsp;</b>Se pondrá a la venta toda arma que deba ${forfeit} meses de almacenamiento sin notificación previa.</div>
  </div>
  <div class="foot"><b>B &amp; B TARGET CENTER, INC.</b><br/>Address: 369 Ave. San Claudio Suite #3, San Juan, Puerto Rico 00926<br/>Tels. 787-755-9060 / 787-761-0735 / Fax. 787-755-9290<br/>Web: www.bbtargetcenter.com / E-mail: tuto@bbtargetcenter.com</div>
  <div class="ref">Impreso ${new Date().toLocaleString('es-PR')}${l.id ? ` · Ref. ${esc(l.id)}` : ''}${l.contractNumber ? ` · Contrato ${esc(l.contractNumber)}` : ''}</div>
  <script>window.onload=function(){setTimeout(function(){window.print()},150)}</script>
  </body></html>`;
  w.document.write(html);
  w.document.close();
};

// Custodia (pedido Paola 2026-10-06): varias armas en un expediente, sin
// precio; se paga almacenaje mensual por arma, todas en un solo pago.
export const isCustody = (l) => Boolean(l && l.kind === 'custody');
export const firearmCount = (l) => (isCustody(l) ? Math.max(1, Number(l.firearmCount) || (Array.isArray(l.firearms) ? l.firearms.length : 1)) : 1);
export const oneFirearmLabel = (f) => [f.brand, f.model, f.caliber ? `(${f.caliber})` : ''].filter(Boolean).join(' ') || f.firearmType || 'Arma';
export const firearmLabel = (l) => {
  if (isCustody(l)) {
    const list = (l.firearms || []).map(oneFirearmLabel);
    const n = list.length || firearmCount(l);
    return `Custodia · ${n} arma${n === 1 ? '' : 's'}${list.length ? `: ${list.slice(0, 3).join(', ')}${list.length > 3 ? '…' : ''}` : ''}`;
  }
  return oneFirearmLabel(l);
};
// Almacenaje mensual (sin IVU) de un layaway o custodia
export const monthlyStorageCents = (l, settings) => (Number(settings.storageFeeCents) || 0) * firearmCount(l);
// Meses de almacenaje que debe una custodia o un arma SALDADA vencida (cada 30 días = 1 mes)
export const monthsOwed = (l, settings) => {
  if (!l || !(isCustody(l) || l.status === 'paid')) return 0;
  const dl = daysLeft(l);
  if (dl === null || dl >= 0) return 0;
  return Math.ceil(-dl / (Number(settings.storageMonthDays) || 30));
};
// ¿Puede extender el contrato (cláusula 8)? Solo layaway activo con balance y
// sin agotar las extensiones permitidas (0 = sin límite).
export const canExtendContract = (l, settings) => {
  if (!l || isCustody(l) || l.status !== 'active' || !((Number(l.balanceCents) || 0) > 0)) return false;
  const max = Number(settings && settings.extensionMaxCount) || 0;
  return max === 0 || (Number(l.extensionCount) || 0) < max;
};
export const extensionTotalCents = (settings) => {
  const fee = Number(settings && settings.extensionFeeCents) || 0;
  return fee + (settings && settings.extensionFeeTaxable !== false ? calcTaxCents(fee) : 0);
};

export const staffName = () => {
  const id = getCurrentIdentity();
  return id.displayName || id.email || 'staff';
};

const post = async (fn, body) => {
  try {
    const r = await axios.post(`${FUNCTIONS_BASE}/${fn}`, body);
    return r.data;
  } catch (e) {
    const msg = (e.response && e.response.data && e.response.data.error) || e.message || 'Error';
    throw new Error(msg);
  }
};

export const layawayApi = {
  create: (data) => post('adminCreateLayaway', { ...data, staffName: staffName() }),
  recordPayment: (data) => post('adminRecordLayawayPayment', { ...data, staffName: staffName() }),
  update: (layawayId, action, extra = {}) => post('adminUpdateLayaway', { layawayId, action, staffName: staffName(), ...extra }),
  editPayment: (layawayId, paymentId, data) => post('adminUpdateLayaway', { layawayId, action: 'editPayment', paymentId, staffName: staffName(), ...data }),
  voidPayment: (layawayId, paymentId, note) => post('adminUpdateLayaway', { layawayId, action: 'voidPayment', paymentId, note, staffName: staffName() }),
  runDaily: (dryRun = true) => post('runLayawaysDailyNow', { dryRun }),
};
